import React from 'react'
import Navbar from '../../components/navbar'
import { Link } from 'react-router-dom'

import bg1 from '../../assets/images/property/bg.jpg'
import Partner from '../../components/partner'

import buyer from '../../assets/images/icon/buyer.svg'
import sales from '../../assets/images/icon/sales.svg'
import cta from '../../assets/images/property/cta.jpg'
import ClientTwo from '../../components/client-two'
import { propertyData } from '../../data/data'
import map from '../../assets/images/illustrator/map_mobile.svg'
import CountUp from 'react-countup'
import Footer from '../../components/footer'

export default function IndexProperty() {
  return (
    <>
    <Navbar navLight={true}/> 
    <section className="bg-half-260 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row justify-content-center mt-4">
              <div className="col-lg-8 col-md-10 text-center">
                  <div className="title-heading mt-4">
                      <h1 className="heading text-white title-dark mb-3">Sale & Buy Your Property</h1>
                      <p className="para-desc mx-auto text-light title-dark">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="text-center subcribe-form mt-5">
                          <form>
                              <input type="text" id="keywords" name="name" className=" rounded-pill" required placeholder="Search your Keywords.."/>
                              <button type="submit" className="btn btn-primary rounded-pill">Search</button>
                          </form>
                      </div>
                      <p className="text-white-50 mb-0 mt-3"><span className="text-light title-dark">Keywords :</span> Home, House, Flat, Row house, etc...</p>
                  </div>
              </div>
          </div>
      </div> 
      <div className="home-shape-arrow">
          <Link to="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon text-dark h5"></i></Link>
      </div> 
    </section>

    <section className="section">
      <div className="container">
          <div className="row">
              <Partner/>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Two Parameters</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                  <div className="row">
                      <div className="col-md-6 mt-4 pt-2">
                          <div className="catagories p-4 border text-center rounded bg-white">
                              <img src={buyer} className="img-fluid avatar avatar-medium" alt=""/>
                              <div className="mt-3">
                                  <h5>Buy Property</h5>
                                  <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.</p>
                                  <Link to="#" className="btn btn-primary">Buy Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                              </div>
                          </div>
                      </div>
                      
                      <div className="col-md-6 mt-4 pt-2">
                          <div className="catagories p-4 border text-center rounded bg-white">
                              <img src={sales} className="img-fluid avatar avatar-medium" alt=""/>
                              <div className="mt-3">
                                  <h5>Sale Property</h5>
                                  <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.</p>
                                  <Link to="#" className="btn btn-primary">Sale Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section style={{backgroundImage:`url(${cta})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-dark shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section" id="listing">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mt-5 pt-4">
                      <h4 className="title mb-4">Property Listing</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row mt-4 pt-2">
            {propertyData.map((item,index)=>{
              return(
                <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                    <div className="property-list border rounded position-relative overflow-hidden">
                        <div className="image position-relative overflow-hidden">
                            <img src={item.image} className="img-fluid" alt=""/>
                            <div className="overlay bg-dark"></div>
                            <h4 className="price text-white mb-0">{item.value}</h4>
                            <ul className="list-inline text-white mb-0 details">
                                <li className="h6"><i className="mdi mdi-account"></i> {item.userName}</li>
                                <li className="h6"><Link to="tel:+152534-468-854" className="text-white"><i className="mdi mdi-phone"></i> {item.contact}</Link></li>
                                <li className="h6 mb-0"><Link to="#" className="video-play-icon lightbox text-white"><i className="mdi mdi-map-marker"></i> {item.name}</Link></li>
                            </ul>
                        </div>
                        <div className="content p-3">
                            <h5><Link to="#" className="text-dark">{item.name}</Link></h5>
                            <h6 className="text-muted mb-0"><i className="mdi mdi-map-marker text-warning"></i> {item.loction}</h6>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <img src={map} className="mover" alt=""/>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title ms-md-5">
                      <span className="badge bg-primary"> Property </span>
                      <h4 className="title mt-3 mb-4">Housing Service Through Application</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center" id="counter">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">See our <span className="text-primary"><CountUp end={25000}/>+</span> customers selling and buying houses</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  
                      <div className="mt-4">
                          <Link to="#" className="btn btn-primary mt-2 me-2">Buy Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                          <Link to="#" className="btn btn-outline-primary mt-2">Sale Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
